module.exports = __webpack_public_path__ + "img/poke2.351af522.jpg";